const servicesUrl = {
    'LOCAL': 'https://localhost:55006/api/',
    'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/phf-service/api/',
    'QA': 'https://phf-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/api/',
    'TEST': 'https://phf-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/api/',
    'PROD':'https://mesc-service.musea2.azure.ext.gm.com/phf-service/api/'
};


export const phfInfo = {
    route: '/PHF',
    title: 'PHF',
    subtitle: 'Part Handling Forum',
    description: 'Part Handling Forum',
    adminDescription: 'Part Handling Forum Administration',
    image: 'image-phf',
    version: '1.9.0.0',
    revisionDate: '2018-12-12T11:15:21+00:00',
    services: servicesUrl
}



